import jwt from "jsonwebtoken";

const queryString = require('query-string');
const jwtKey = process.env.REACT_APP_JWT_KEY;

/*
    This is the main component that will be used to print the voucher
    @todo - JWT in code, make API driven
 */
export default function Voucher() {

    const parsed = queryString.parse(window.location.search);

    try {
        const decoded = jwt.verify(parsed.cid, jwtKey);
        return (
            <ShowVoucher decoded={decoded} />
        )
    } catch(err) {
        return (
            <h1>Not valid</h1>
        )
    }
}

/*
    This is the main component that will be used to print the voucher
    @param decoded - the decoded JWT token
 */
const ShowVoucher = ({decoded}) => {
    return (
        <div style={{padding:20}}>
            Voucher: {decoded.voucher}
        </div>
    )
}
